module.exports = __webpack_public_path__ + "img/spot_red_log.3604fd60.svg";